import React, { Component, PropTypes } from 'react'
import { Modal, Button } from 'react-bootstrap'
import MarkdownScript from 'helpers/markdownScript'
import dataUsagePolicy from './dataUsage.md'

const md = new MarkdownScript(dataUsagePolicy)

export default class dataUsageModal extends Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired
  }

  render () {
    return (
      <Modal
        show={this.props.showModal}
        onHide={this.props.closeModal}
      >
        <Modal.Body>
          <div dangerouslySetInnerHTML={{__html: md.getAllAsHtml()}} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.closeModal()}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/dataUsageModal.jsx